import { IEditorV3 } from "@azu-business/editor-v3";
import { ARS, ArsTableBody, ArsTableRow, LoadFunctionWithData } from "aic";
import axios from "axios";
import { processAxiosError } from "../processAxiosError";

export interface ArsCalculationDto {
  arsTableBody: ArsTableBody<IEditorV3>;
  analysisSet?: ARS.AnalysisSet;
  dataSubset?: ARS.DataSubset;
}

export interface ArsCalculationResultDto {
  rows: ArsTableRow<IEditorV3>[];
  variables: Set<string>;
}

/**
 * Fetches ARS table calculation results based on the provided ARS table body parameters.
 *
 * @param backEndUrl - Base backend URL
 * @param params - ARS table body including IDs, columns, rows and row headers
 * @param controller - AbortController to cancel the request if needed
 * @returns A promise that resolves to the ARS table calculation results or an error
 */
export const getArsTableCalculation: LoadFunctionWithData<
  ArsCalculationDto,
  ArsCalculationResultDto
> = async (backEndUrl: string, params: ArsCalculationDto, controller: AbortController) => {
  try {
    const url = `${backEndUrl}Ars/ArsTableCalculation`;

    const response = await axios.post(url, params, {
      signal: controller.signal,
    });

    return {
      success: true,
      data: {
        rows: response.data.rows,
        variables: new Set(response.data.variables),
      },
    };
  } catch (error) {
    return processAxiosError(
      "Get ARS table calculation failed - please refresh the page and try again",
      error,
    );
  }
};
